(function () {
  function initRoles(root) {
    if (!root) return;

    var container = root.querySelector('[data-careers-roles]');
    if (!container) return;

    var searchInput = container.querySelector('[data-careers-role-search]');
    var deptSelect = container.querySelector('[data-careers-role-dept]');
    var items = container.querySelectorAll('[data-careers-role-item]');
    var panels = container.querySelectorAll('[data-careers-role-panel]');
    var emptyEl = container.querySelector('[data-careers-roles-empty]');

    function getItemTitle(item) {
      return (item.getAttribute('data-role-title') || '').toLowerCase();
    }

    function getItemDepartment(item) {
      return (item.getAttribute('data-role-department') || '').trim();
    }

    function getPanelDepartment(panel) {
      return (panel.getAttribute('data-role-department') || '').trim();
    }

    function getSearchQuery() {
      return searchInput ? (searchInput.value || '').trim().toLowerCase() : '';
    }

    function getDeptFilter() {
      return deptSelect ? (deptSelect.value || '').trim() : '';
    }

    function showPanel(panelId) {
      panels.forEach(function (p) {
        var isActive = panelId && p.id === panelId;
        p.classList.toggle('is-active', isActive);
        p.hidden = !isActive;
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      items.forEach(function (btn) {
        var id = btn.getAttribute('aria-controls') || btn.getAttribute('data-role-id');
        btn.classList.toggle('is-active', id === panelId);
        btn.setAttribute('aria-selected', id === panelId ? 'true' : 'false');
      });
    }

    function updateVisibility() {
      var query = getSearchQuery();
      var dept = getDeptFilter();
      var visibleCount = 0;
      var firstVisibleId = null;

      items.forEach(function (item) {
        var title = getItemTitle(item);
        var itemDept = getItemDepartment(item);
        var matchSearch = !query || title.indexOf(query) !== -1;
        var matchDept = !dept || itemDept === dept;
        var visible = matchSearch && matchDept;
        item.style.display = visible ? '' : 'none';
        if (visible) {
          visibleCount++;
          if (!firstVisibleId) firstVisibleId = item.getAttribute('aria-controls') || item.getAttribute('data-role-id');
        }
      });

      if (emptyEl) {
        emptyEl.hidden = visibleCount > 0;
      }

      container.setAttribute('data-empty', visibleCount === 0 ? 'true' : 'false');

      if (firstVisibleId) {
        showPanel(firstVisibleId);
      } else {
        showPanel(null);
      }
    }

    function openFromHash() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      if (!hash) return;
      var panel = container.querySelector('#' + hash);
      if (panel && panel.getAttribute('data-careers-role-panel') !== null) {
        showPanel(hash);
        var btn = container.querySelector('[aria-controls="' + hash + '"]');
        if (btn) btn.focus();
      }
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var panelId = item.getAttribute('aria-controls') || item.getAttribute('data-role-id');
        if (panelId) {
          showPanel(panelId);
          window.history.replaceState(null, '', '#' + panelId);
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', updateVisibility);
    }
    if (deptSelect) {
      deptSelect.addEventListener('change', updateVisibility);
    }

    window.addEventListener('hashchange', openFromHash);
    openFromHash();
    updateVisibility();
  }

  function initApplyModal(root) {
    if (!root) return;
    var modal = root.querySelector('#careers-apply-modal');
    var form = root.querySelector('[data-careers-apply-form]');
    var jobTitleInput = root.querySelector('#apply-job-title');
    var jobTitleDisplay = root.querySelector('#careers-apply-modal-job');
    var statusEl = root.querySelector('#careers-apply-form-status');
    var submitBtn = root.querySelector('#apply-submit-btn');
    var endpoint = form && form.getAttribute('data-endpoint');
    var applyButtons = root.querySelectorAll('.careers__apply-btn');
    var successScreen = root.querySelector('#careers-apply-success');
    var formWrap = root.querySelector('#careers-apply-form-wrap');

    function showForm() {
      if (successScreen) {
        successScreen.hidden = true;
        successScreen.setAttribute('hidden', '');
      }
      if (formWrap) {
        formWrap.hidden = false;
        formWrap.removeAttribute('hidden');
      }
    }

    function showSuccess() {
      if (formWrap) {
        formWrap.hidden = true;
        formWrap.setAttribute('hidden', '');
      }
      if (successScreen) {
        successScreen.hidden = false;
        successScreen.removeAttribute('hidden');
      }
    }

    var savedScrollY = 0;

    function openModal(jobTitle) {
      if (!modal) return;
      savedScrollY = window.scrollY || window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      showForm();
      var title = (jobTitle || '').trim();
      if (jobTitleInput) jobTitleInput.value = title;
      if (jobTitleDisplay) {
        jobTitleDisplay.textContent = title ? 'Applying for: ' + title : '';
      }
      modal.hidden = false;
      modal.removeAttribute('hidden');
      if (form) form.reset();
      if (jobTitleInput && title) jobTitleInput.value = title;
      if (statusEl) {
        statusEl.hidden = true;
        statusEl.removeAttribute('data-status');
        statusEl.textContent = '';
      }
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, savedScrollY);
    }

    function setStatus(message, type) {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.setAttribute('data-status', type || '');
      statusEl.hidden = false;
    }

    function readFileAsBase64(file, cb) {
      var reader = new FileReader();
      reader.onload = function () {
        var dataUrl = reader.result;
        var base64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
        cb(null, base64);
      };
      reader.onerror = function () { cb(new Error('Failed to read file')); };
      reader.readAsDataURL(file);
    }

    applyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-job-title') || '');
      });
    });

    root.querySelectorAll('[data-apply-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    if (modal && modal.querySelector('.careers-apply-modal__backdrop')) {
      modal.querySelector('.careers-apply-modal__backdrop').addEventListener('click', closeModal);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!endpoint || endpoint === '') {
          setStatus('Form submission is not configured. Please add the Apply form endpoint URL in theme settings.', 'error');
          return;
        }
        var name = (form.querySelector('#apply-name') && form.querySelector('#apply-name').value || '').trim();
        var email = (form.querySelector('#apply-email') && form.querySelector('#apply-email').value || '').trim();
        var phone = (form.querySelector('#apply-phone') && form.querySelector('#apply-phone').value || '').trim();
        var why = (form.querySelector('#apply-why') && form.querySelector('#apply-why').value || '').trim();
        var sponsorship = (form.querySelector('#apply-sponsorship') && form.querySelector('#apply-sponsorship').value || '').trim();
        var resumeInput = form.querySelector('#apply-resume');
        if (!name || !email || !phone || !why || !sponsorship) {
          setStatus('Please fill in all required fields.', 'error');
          return;
        }
        if (email.indexOf('@') === -1) {
          setStatus('Please enter a valid email address.', 'error');
          return;
        }
        if (!resumeInput || !resumeInput.files || !resumeInput.files[0]) {
          setStatus('Please attach your resume.', 'error');
          return;
        }
        var file = resumeInput.files[0];
        var maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
          setStatus('Resume must be 10 MB or smaller.', 'error');
          return;
        }
        if (submitBtn) submitBtn.disabled = true;
        setStatus('Sending...', '');
        var resumeBase64El = form.querySelector('#apply-resume-base64');
        var resumeFilenameEl = form.querySelector('#apply-resume-filename');
        readFileAsBase64(file, function (err, base64) {
          if (err) {
            setStatus('Could not read resume file.', 'error');
            if (submitBtn) submitBtn.disabled = false;
            return;
          }
          if (resumeBase64El) resumeBase64El.value = base64;
          if (resumeFilenameEl) resumeFilenameEl.value = file.name;
          form.setAttribute('action', endpoint);
          form.setAttribute('target', 'careers-apply-iframe');
          var fallbackTimer = setTimeout(function () {
            fallbackTimer = null;
            if (submitBtn) submitBtn.disabled = false;
            showSuccess();
            if (form) form.reset();
            if (jobTitleInput && jobTitleInput.value) jobTitleInput.value = jobTitleInput.value;
          }, 5000);
          window.__careersApplyFallbackTimer = fallbackTimer;
          form.submit();
        });
      });
    }

    window.addEventListener('message', function (event) {
      if (event.data && event.data.type === 'careers-apply-result') {
        if (window.__careersApplyFallbackTimer) {
          clearTimeout(window.__careersApplyFallbackTimer);
          window.__careersApplyFallbackTimer = null;
        }
        if (submitBtn) submitBtn.disabled = false;
        if (event.data.success) {
          if (form) form.reset();
          if (jobTitleInput && jobTitleInput.value) jobTitleInput.value = jobTitleInput.value;
          showSuccess();
        } else {
          setStatus(event.data.message || 'Something went wrong. Please try again or email us directly.', 'error');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-careers-root]');
    initRoles(root);
    initApplyModal(root);
  });
})();
